export default __webpack_public_path__ + "static/media/img_stop.2e160c7e.svg";